import { useEffect } from 'react';
import { Routes, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';
import * as Sentry from '@sentry/react';

const isProdOrStagingEnv = ['staging', 'production'].includes(import.meta.env.VITE_ENV);

Sentry.init({
    dsn: 'https://26eff36569fbba34cbd7194d736e1d7a@o4509203114098688.ingest.us.sentry.io/4509434868400128',
    enabled: isProdOrStagingEnv,
    sendDefaultPii: true,
    environment: import.meta.env.VITE_ENV,

    allowUrls: [/^https:\/\/aiq(-staging)?\.birdseyesecurity\.com/],
    tracePropagationTargets: [/^https:\/\/aiq(-staging)?\.birdseyesecurity\.com/],
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
    ],
    tracesSampleRate: 1.0,
});

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
